//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//user
import User from '../views/user/Index.vue';
import UserLista from '../views/user/Lista.vue';
import UserForm from '../views/user/Form.vue';
//olt
import Olt from '../views/olt/Index.vue';
import OltLista from '../views/olt/Lista.vue';
import OltForm from '../views/olt/Form.vue';
import OltAdmin from '../views/olt/Admin.vue';
import OltStatus from '../views/olt/Status.vue';
//ont
import Ont from '../views/ont/Index.vue';
import OntLista from '../views/ont/Lista.vue';
import OntPower from '../views/ont/Power.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/user',
    component: User,
    children: [
      {
        path: "/",
        component: UserLista
      },
      {
        path: ":id",
        component: UserForm
      }
    ]
  },
  {
    path: '/olt',
    component: Olt,
    children: [
      {
        path: "/",
        component: OltLista
      },
      {
        path: ":id",
        component: OltForm
      },
      {
        path: "admin/:id",
        component: OltAdmin
      },
      {
        path: "status/:id",
        component: OltStatus
      }
    ]
  },
  {
    path: '/ont',
    component: Ont,
    children: [
      {
        path: "/",
        component: OntLista
      },
      {
        path: "power",
        component: OntPower
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;